// @flow
import React from 'react';
import CreateAccountValueProp from 'app/common/react/components/growth/smb/CreateAccountValueProp/CreateAccountValueProp';
import i18n from 'app/common/lib/i18n';

export default () => (
  <CreateAccountValueProp
    title={i18n._('Reach people making decisions', 'Value prop features title')}
    sections={[
      {
        heading: i18n._('Analytics', 'Value prop monthly features heading'),
        subtitle: i18n._(
          'Track which Pins are performing the best',
          'Value prop monthly statistic subtitle',
        ),
      },
      {
        heading: i18n._('Insights', 'Value prop search features heading'),
        subtitle: i18n._(
          'Learn more about your audience on Pinterest',
          'Value prop search statistic subtitle',
        ),
      },
      {
        heading: i18n._('Ads', 'Value prop user action features heading'),
        subtitle: i18n._(
          'Reach new audiences with Pinterest Ads',
          'Value prop user action statistic subtitle',
        ),
      },
    ]}
  />
);
